module.exports = __webpack_public_path__ + "img/wordmark.7cf2c6f9.svg";